import store from '@/store';
import { PREPROD as PREPROD_ENVIRONMENT, PROD as PROD_ENVIRONMENT } from '@/assets/common/environment';

const { getters } = store;
const SYS_ADMIN_ROLE = getters['auth/SYS_ADMIN_ROLE'];
const ADMIN_ROLE = getters['auth/ADMIN_ROLE'];
const AGENT_ROLE = getters['auth/AGENT_ROLE'];

export default [
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/login/Index'),
        meta: {
            title: 'Login',
            guestOnly: true,
            layout: 'auth'
        }
    },
    {
        path: '/login_sandbox',
        name: 'login_sandbox',
        component: () => import('@/views/login-sandbox/Index'),
        meta: {
            title: 'Login Sandbox',
            guestOnly: true,
            layout: 'auth'
        }
    },
    {
        path: '/login_code',
        name: 'login_code',
        component: () => import('@/views/login-code/Index'),
        meta: {
            title: 'Login Code',
            guestOnly: true,
            layout: 'auth'
        }
    },
    {
        path: '/sign-up',
        name: 'sign-up',
        component: () => import('@/views/sign-up/Index'),
        meta: {
            title: 'Sign up',
            guestOnly: true,
            layout: 'auth'
        }
    },
    {
        path: '/reset-password/:token',
        name: 'resetPassword',
        component: () => import('@/views/reset-password/Index'),
        meta: {
            title: 'Reset password',
            guestOnly: true,
            layout: 'auth'
        }
    },
    {
        path: '/forget-password',
        name: 'forgetPassword',
        component: () => import('@/views/forget-password/Index'),
        meta: {
            title: 'Forget Password',
            guestOnly: true,
            layout: 'auth'
        }
    },
    {
        path: '/logout',
        name: 'logout',
        component: () => import('@/views/logout/Index'),
        meta: {
            title: 'Logout',
            layout: 'loader',
            authRequired: true
        }
    },
    {
        path: '/moderation-report',
        name: 'moderationReport',
        component: () => import('@/views/moderation-report/Index'),
        meta: {
            authRequired: true,
            title: 'Moderation Report'
        }
    },

    {
        path: '/admin',
        name: 'admin',
        component: () => import('@/views/admin/Index'),
        meta: {
            title: 'Admin Management',
            authRequired: true,
            roles: [SYS_ADMIN_ROLE]
        }
    },

    {
        path: '/inbox',
        name: 'inbox',
        component: () => import('@/views/inbox/Index'),
        meta: {
            title: 'Inbox',
            authRequired: true,
            excludedEnvironments: [PROD_ENVIRONMENT]
        }
    },

    {
        path: '/search',
        name: 'search',
        component: () => import('@/views/search/Index'),
        meta: {
            title: 'Search',
            authRequired: true,
            excludedEnvironments: [PROD_ENVIRONMENT]
        }
    },

    {
        path: '/settings',
        name: 'settings',
        component: () => import('@/views/settings/Index'),
        meta: {
            title: 'Settings',
            authRequired: true,
            roles: [SYS_ADMIN_ROLE, ADMIN_ROLE, AGENT_ROLE]
        },
        children: [
            {
                path: 'users',
                name: 'users',
                component: () => import('@/views/settings/users/Index'),
                meta: {
                    title: 'Users'
                }
            },
            {
                path: 'channels',
                name: 'channels',
                component: () => import('@/views/settings/channels/Index'),
                meta: {
                    title: 'Channels'
                }
            },
            {
                path: 'teams',
                name: 'teams',
                component: () => import('@/views/settings/teams/Index'),
                meta: {
                    title: 'Teams'
                }
            }
        ]
    },

    {
        path: '/topics/:topicId?',
        name: 'topics',
        component: () => import('@/views/topics/Index'),
        meta: {
            title: 'Topics',
            authRequired: true
        }
    },

    {
        path: '/account/settings',
        name: 'accountSettings',
        component: () => import('@/views/account/settings/Index'),
        meta: {
            title: 'Settings',
            authRequired: true
        },
        children: [
            {
                path: 'preferences',
                name: 'preferences',
                component: () => import('@/views/account/settings/preferences/Index'),
                meta: {
                    title: 'Preferences'
                }
            },
            {
                path: 'safety-and-privacy',
                name: 'safety-and-privacy',
                component: () => import('@/views/account/settings/safety-and-privacy/Index'),
                meta: {
                    title: 'Safety and Privacy'
                }
            },
            {
                path: 'sentiment',
                name: 'sentiment-exclude-terms',
                component: () => import('@/views/account/settings/sentiment/terms/Index'),
                meta: {
                    title: 'Sentiment Exclude Terms'
                }
            },
            {
                path: 'sso',
                name: 'single-sign-on',
                component: () => import('@/views/account/settings/sso/Index'),
                meta: {
                    title: 'Single Sign On'
                }
            },
            {
                path: 'mcp-api-key',
                name: 'mcp-api-key',
                component: () => import('@/views/account/settings/mcp-api-key/Index'),
                meta: {
                    title: 'MCP API Key'
                }
            },
        ]
    },

    // @TMP

    {
        path: '/charts',
        name: 'charts',
        component: () => import('@/views/charts/Index'),
        meta: {
            title: 'Charts',
            authRequired: true,
            excludedEnvironments: [PROD_ENVIRONMENT, PREPROD_ENVIRONMENT]
        }
    },

    {
        path: '/helper',
        name: 'helper',
        component: () => import('@/views/helper-tab/Index'),
        meta: {
            title: 'Helper'
        }
    },

    // {
    //     path: '/helper-tab',
    //     name: 'helper-tab',
    //     component: () => import('@/views/helper-tab/Index'),
    //     meta: {
    //         title: 'Helper'
    //     }
    // },

    {
        path: '/',
        name: 'dashboard',
        component: () => import('@/views/dashboard/Index'),
        meta: {
            title: 'Dashboard',
            authRequired: false
        }
    },

    {
        path: '/:catchAll(.*)',
        name: 'erroPage',
        component: () => import('@/layouts/error'),
        meta: {
            title: 'Page not found',
            layout: (() => (store.getters['auth/isLoggedIn'] ? 'default' : 'auth'))()
        }
    },

    {
        path: '/how_to',
        name: 'how_to',
        component: () => import('@/views/how-to/Index'),
        meta: {
            title: 'How To'
        }
    },

    {
        path: '/mcp_access',
        name: 'mcp_access',
        component: () => import('@/views/mcp-access/Index'),
        meta: {
            title: 'MCP Access'
        }
    }
];
